<template>
  <div class="activity_list" v-if="List.length">
    <div class="title">
      <img src="../../../assets/img/new/icon-brand-l.png" >
      <span>Activity</span>
      <img src="../../../assets/img/new/icon-brand-r.png" >
    </div>
    <div class="ex_list" >
      <div class="item_div" v-for="(item,index) in List" :key="index" @click="LinkAct(item)">
        <div class="img_div">
          <img :src="item.banners"  v-load="'oActSmall'"  >
        </div>
        <div class="item_info">
          <div class="item_title">
            <p class="van-ellipsis">{{item.title}}</p>
            <!-- <div class="is_live is_ac_end" v-if="item.stateIndex==3">已结束</div> -->
            <template v-if="item.acvitityType=='LIVE'&&(item.liveAuditState=='PASS'||item.liveAuditState=='Pass')">
              <div class="is_live is_liveing" v-if="item.liveStateIndex===1"><span></span> Live</div>
              <!-- <div class="is_live" v-else-if="item.liveStateIndex===2"><i class="iconfont icon-zhibo"></i>有直播</div> -->
              <!-- <div class="is_live is_end" v-else-if="item.hasLive">直播回看</div> -->
            </template>
          </div>
          <p class="van-ellipsis item_date">{{item.dateTime}}</p>
          <p class="van-ellipsis item_site">{{item.company.nameEn}}</p>
          <div class="van-ellipsis ex_info">
            <p>
              <i class="iconfont icon-fenxiang2"></i>
              <span>{{wCount(item.shareCount)}}</span>
            </p>
            <p>
              <i class="iconfont icon-zhiboguankanshu"></i>
              <span>{{wCount(item.viewCount)}}</span>
            </p>
            <p>
              <i class="iconfont icon-huabanfuben"></i>
              <span>{{wCount(item.followCount)}}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- <div v-else style="padding: 0.3rem 0 0.5rem;text-align: center;">暂无内容</div> -->
    <div class="more_btn loading" v-if="Loading&&!finished"><img src="@assets/img/new/icon-loading.png" />Loading...</div>
    <div class="more_btn" @click="loadMore" v-if="!finished">MORE<i class="iconfont icon-right-fill "></i></div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import moment from "moment";
import { mapGetters, mapActions } from "vuex";
export default {  
  name: "activity-list",
  data() {
    return {
      Loading: false, //活动动态加载状态
      finished: false, //活动加载是否完成状态
      List: [], //活动列表
      pageIndex:1,
      pageSize:3,
      activityEx:{},    //获取指定展商活动
    };
  },
  components: {},
  computed: {
    ...mapGetters({
      exhibitionId: "getExhibitionId",
    }),
    exhibitorId(){
      return this.$route.params.id;
    }
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions({
      getAddedList: "connection/getAddedList",
      LinkAct:"linkTo/LinkAct"
    }),
    wCount(value) {
      //过万处理
      let num = value;
      if (value > 9999) {
        //大于9999显示x.xx万
        num = Math.floor(value / 100) / 100 + "w";
      } else {
        num = value;
      }
      return num;
    },
    getData(isLoad=false){
      let query=gql`
        query getActivityExhibitor($exhibitorId:Guid!,$page:Int!,$size:Int!){
          activityEx:getActivityExhibitor(
            exhibitorId:$exhibitorId,
            page: $page,
            size: $size
          ) {
            hasNextPage
            pageIndex
            pageSize
            items {
              auditState
              id
              title
              titleEn
              banners
              startTime	 #开始时间
              endTime		 #结束时间
              shareCount #分享数
              viewCount  #浏览数
              followCount #关注数
              acvitityType #活动类型，0/ExternalLink：外链、1/Live：直播、 2/Registration：报名
              externalLink #外链地址
              stateIndex #活动进行状态 1：进行中、2：未开始：3：已结束
              liveStateIndex
              liveAuditState
              hasLive
              company{
                id
                name
                nameEn
              }
            }
          }
        }`
      let where={
        "Equal":{
          "n":"exhibitorId",
          "v":this.exhibitorId
        },
        "Equal3":{
          "n":"isShow",
          "v": 1
        },
      }
      let order=[
        {
          "N":"showIndex",
          "v":0
        }
      ]
      this.$apollo.addSmartQuery("activityEx",{
        query:query,
        variables:{
          exhibitorId:this.exhibitorId,
          page:this.pageIndex,
          size:this.pageSize,
        },
        fetchPolicy: "network-only", //清理缓存
        result(data){
          let res=JSON.parse(JSON.stringify(data.data.activityEx));
          console.log('getActivityExhibitor  data',res);
          res.items.forEach(e => {
            if(e.banners&&e.banners.indexOf('[')!=-1){
              let banArr=JSON.parse(e.banners);
              e.banners=banArr[0];
            }
            let str=moment(e.startTime).format("MM/DD HH:mm");
            str+='~'+moment(e.endTime).format("MM/DD HH:mm");
            e.dateTime=str;
          });
          this.Loading=false;
          if(this.pageIndex==1){
            this.List=res.items
          }else{
            this.List=[...new Set([...this.List,...res.items])];
          }
          console.log(this.List);
          if(isLoad){
            this.pageIndex=res.pageIndex
          }else{
            this.pageIndex=0
            this.pageSize=10
          }
          if (!res.hasNextPage) {
            this.finished = true;
          }
        },
        error(err){
          this.Loading=false;
          console.log('err',err)
        }
      })
    },
    loadMore() {
      if (this.finished) return;
      this.Loading = true;
      this.pageIndex += 1;
      this.getData(true);
    },
  }
};
</script>

<style scoped lang="scss">
//展品列表
.activity_list{
  background: #fff;
  margin-top:0.2rem;
  border-radius: 0.3rem;
  padding: 0.2rem 0.3rem 0 0.2rem;
  color: #333;
  .title{
    height: 0.77rem;
    display: flex;
    justify-content: center;
    align-items: center;
    span{
      font-size: 0.32rem;
      font-weight: bold;
      margin: 0 0.2rem;
    }
    img{
      height: 0.2rem;
      width: 0.42rem;
    }
  }
  .ex_list{
    .item_div{
      padding: 0.3rem 0;
      border-bottom: 1px solid #e6e6e6;
      display: flex;
      &:last-child{
        border: none;
      }
      .img_div{
        flex-shrink: 0;
        position: relative;
        height: 1.24rem;
        width: 2.2rem;
        border-radius: 0.05rem;
        border: 1px solid #e6e6e6;
        overflow: hidden;
        margin-right: 0.2rem;
        img{
          width: 100%;  
          height: 100%;
          // object-fit: cover;
        }
      }
      .item_info{
        max-width: calc(100% - 2.4rem);
        display: flex;
        margin-bottom: -0.05rem;
        justify-content: space-between;
        flex-direction: column;
        color: #666;
        .item_title{
          display: flex;
          align-items: center;  
          p{
            font-size: 0.26rem;
            font-weight: bold;
            color: #333;
            min-height:0.3rem ;
          }
          .is_live{
            width: 0.88rem;
            height:0.3rem;
            display: flex;
            flex-shrink: 0;
            justify-content: center;
            align-items: center;  
            color: #fff;
            margin-left:0.15rem;
            border-radius:0.05rem;
            background-image: linear-gradient(90deg,#56ccf2 0%, #2f80ed 100%);
            font-size: 0.18rem;
            &.is_liveing{
              background-image: linear-gradient(90deg,#ff416c 0%,#ff4b2b 100%);
            }
            &.is_ac_end{
              background: #bfbfbf;
            }
            &.is_end{
              background-image: linear-gradient(90deg, 
            #ffc659 0%, 
            #ffa751 100%), 
          linear-gradient(
            #000, 
            #000);
            }
            span{
              display: block;
              height:0.12rem;
              width:0.12rem;
              margin-right: 0.05rem;
              border-radius: 50%;
              background: #fff;
            }
            .iconfont{
              color: #fff;
              font-size: 0.24rem;
              margin-left: -0.04rem;
            }
          }
         
        }
        .item_date{
          font-size: 0.2rem;
        }
        .item_site{
          font-size: 0.22rem;
          min-height: 0.24rem;
        }
        .ex_info{
          color: #999;
          display: flex;
          p {
            margin-right: 0.1rem;
            display: flex;
            align-items: center;
            span{
              font-size: 0.2rem;
            }
          }
        }
      }
    }
  }
  .more_btn{
    font-size: 0.26rem;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 0.75rem;
    width: calc(100% + 0.5rem);
    margin-left: -0.2rem;
    border-top:1px solid  #e6e6e6;
    color: #999;
    &.loading{
      text-align: center;
      img {
        width: 0.30rem;
        height: 0.30rem;
        margin-right: 0.1rem;
        animation: 1s loader-01 linear infinite;
      }
    }
    .iconfont{
      color: #999;
      display: inline-block;
      transform: rotate(90deg) translateX(1px);
      &.shang{
        transform: rotate(-90deg) translateX(-1px);
      }
    }
  }
}
@keyframes loader-01 {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
</style>
